import { useContext } from 'react'
import Auth0ClientConfigContext from './auth0-client-config-context'

export default () => useContext(Auth0ClientConfigContext)
